import Tasks from 'APP/Tasks';

import { GroupsEvent } from '../GroupsEvent';

export class PhonebookWasUpdated extends GroupsEvent {
  process() {
    Tasks.users.getFriends();
  }
}
